<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="purchasePlans">
      <template slot="adSearch">
        <vm-search label="单号：">
          <el-input v-model.trim="filter.billNo" placeholder="请输入单号" clearable/>
        </vm-search>
        <vm-search label="标题：">
          <el-input v-model.trim="filter.billTitle" placeholder="请输入标题" clearable/>
        </vm-search>
        <vm-search label="状态">
          <el-select v-model.trim="filter.status" style="width: 170px" clearable placeholder="请选择">
            <el-option label="供应商未确认" :value="0"/>
            <el-option label="采购退回" :value="1"/>
            <el-option label="采购未确认" :value="2"/>
            <el-option label="已确认" :value="5"/>
          </el-select>
        </vm-search>
        <vm-search label="创建日期：">
          <div class="block">
            <el-date-picker
                v-model="filter.createTimeBegin"
                style="width:150px"
                value-format="yyyy-MM-dd"
                placeholder="请选择"
                type="date"/>
          </div>
        </vm-search>
        <vm-search label="至">
          <div class="block">
            <el-date-picker
                v-model="filter.createTimeEnd"
                style="width:150px"
                value-format="yyyy-MM-dd"
                placeholder="请选择"
                type="date"/>
          </div>
        </vm-search>
      </template>
      <el-table-column prop="billNo" align="center" label="单号" width="150px">
        <template v-slot="scope">
          <span
              style="color: #2d8cf0;cursor: pointer;"
              @click="$refs.detail.open(scope.row)">
            {{scope.row.billNo}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="billTitle" label="标题"/>
      <el-table-column prop="status" align="center" label="状态" width="100px">
        <template v-slot="scope">
          {{getTitle(scope.row.status)}}
        </template>
      </el-table-column>
      <el-table-column prop="createdTime" align="center" label="创建时间" width="150px"/>
      <el-table-column prop="note" label="备注"/>
      <el-table-column
          v-if="editAuth"
          label="操作"
          fixed="right"
          align="center"
          class-name="vm-table_operate"
          width="100px">
        <template v-slot="scope">
          <!--        <el-button type="info">编辑</el-button>-->
          <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <purchase-plan-detail ref="detail" @save-success="getList(-1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import PurchasePlanDetail from "@/views/purchase/purchasePlan/PurchasePlanDetail";

  export default {
    name: "PurchasePlanList",
    components: {VmTable, VmSearch, PurchasePlanDetail},
    data() {
      return {
        editAuth: this.$auth(852),
        filter: {
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      getTitle(val) {
        switch (val) {
          case 0: return "供应商未确认";
          case 1: return "采购退回";
          case 2: return "采购未确认";
          case 5: return "已确认";
        }
      },
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","purchasePlans", row.pkId).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>
<style lang="scss" scoped></style>
